var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass:
                  "class-manage-btn btn btn-outline-primary close-btn mr-2",
                attrs: { type: "button" },
                on: { click: _vm.openStudentManageModal }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("reports.manage_class_students")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile pb-12"
              },
              [_vm._v(_vm._s(_vm.formattedClassName))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mr-12 clickable",
                class: {
                  "class-report-menu-selected": _vm.selectedReport === 1,
                  "class-report-menu-nonselected": _vm.selectedReport !== 1
                },
                on: {
                  click: function($event) {
                    _vm.selectedReport = 1
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("reports.subject_study_status")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clickable",
                class: {
                  "class-report-menu-selected": _vm.selectedReport === 2,
                  "class-report-menu-nonselected": _vm.selectedReport !== 2
                },
                on: {
                  click: function($event) {
                    _vm.selectedReport = 2
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("reports.all_study_status")))]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-15",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row pt-3" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [_vm._v(_vm._s(_vm.$t("common.loading")))]
                  )
                ],
                1
              )
            ])
          : _c("div", [
              _vm.selectedReport === 1
                ? _c("div", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "select-subject-dropdown mnv-dropdown",
                            attrs: {
                              text: _vm.getTranslatedName(
                                _vm.subjectMap[_vm.selectedSubjectId]
                              )
                            }
                          },
                          _vm._l(_vm.subjectIds, function(subjectId) {
                            return _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.selectedSubjectId = parseInt(
                                      subjectId,
                                      10
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTranslatedName(
                                      _vm.subjectMap[subjectId]
                                    )
                                  )
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-outline-rectangle select-assignment-btn",
                            on: {
                              click: function($event) {
                                _vm.selectAssignmentModalIsShown = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.select_assignments")) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-center mr-6 clickable",
                            class: {
                              "student-report-select":
                                _vm.selectedStudentReport === 1,
                              "student-report-nonselect":
                                _vm.selectedStudentReport !== 1
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedStudentReport = 1
                                _vm.sortType = "number"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.need_help_students")) +
                                "  "
                            ),
                            _c(
                              "span",
                              { staticClass: "typography--font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumStrTwoDigit(
                                      _vm.needHelpStudentList.length
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: " text-center clickable",
                            class: {
                              "student-report-select":
                                _vm.selectedStudentReport === 2,
                              "student-report-nonselect":
                                _vm.selectedStudentReport !== 2
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedStudentReport = 2
                                _vm.sortType = "number"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("reports.all_students_report")) +
                                "  "
                            ),
                            _c(
                              "span",
                              { staticClass: "typography--font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumStrTwoDigit(
                                      _vm.studentList.length
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "report-students-info mt-27" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "report-students-info-sort typography--color-secondary"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "display-inlineblock clickable right-border",
                                    class: {
                                      "sort-active": _vm.sortType === "number"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.sortType = "number"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("reports.sort_number")) +
                                        "  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "display-inlineblock clickable",
                                    class: {
                                      "sort-active": _vm.sortType === "score"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.sortType = "score"
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                 " +
                                        _vm._s(_vm.$t("reports.sort_rank")) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1
                              ? _c(
                                  "div",
                                  { staticClass: "report-students-info-title" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("reports.need_help_students")
                                        ) +
                                        "  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typography--font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNumStrTwoDigit(
                                              _vm.needHelpStudentList.length
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2
                              ? _c(
                                  "div",
                                  { staticClass: "report-students-info-title" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("reports.all_students_report")
                                        ) +
                                        "  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typography--font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNumStrTwoDigit(
                                              _vm.studentList.length
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1
                              ? _c(
                                  "div",
                                  { staticClass: "card-block row" },
                                  [
                                    _vm._l(_vm.needHelpStudentList, function(
                                      student,
                                      index
                                    ) {
                                      return _vm.viewMoreNeedHelp ||
                                        index < _vm.viewMoreLength
                                        ? _c(
                                            "Card",
                                            {
                                              staticClass:
                                                "report-students-card"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "report-students-card-header clickable",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.$router.push(
                                                        "/reports/classes/" +
                                                          _vm.cls.id +
                                                          "/students/" +
                                                          student.student_id +
                                                          "?subject_id=" +
                                                          _vm.selectedSubjectId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "report-students-card-header-time":
                                                          _vm.getTotalDuration(
                                                            student.submissions
                                                          ) !== 0,
                                                        "report-students-card-header-time-disabled":
                                                          _vm.getTotalDuration(
                                                            student.submissions
                                                          ) === 0
                                                      }
                                                    },
                                                    [
                                                      _vm.getTotalDuration(
                                                        student.submissions
                                                      ) !== 0
                                                        ? _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/time-icon.svg"
                                                            }
                                                          })
                                                        : _c("img", {
                                                            attrs: {
                                                              src:
                                                                "/static/images/time-gray-icon.svg"
                                                            }
                                                          }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.formattedTime(
                                                              _vm.getTotalDuration(
                                                                student.submissions
                                                              )
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "student-number"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getNumStrTwoDigit(
                                                            student.number
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " \n                  "
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "student-name"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(student.name)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "report-students-card-body clickable"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            "/reports/classes/" +
                                                              _vm.cls.id +
                                                              "/students/" +
                                                              student.student_id +
                                                              "?subject_id=" +
                                                              _vm.selectedSubjectId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "report-students-card-body-titles"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reports.table.score"
                                                                )
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.rank"
                                                                )
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reports.table.complete_rate"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "report-students-card-body-contents"
                                                        },
                                                        [
                                                          _vm.getSubmissionSubjectScore(
                                                            student.submissions,
                                                            _vm.selectedSubjectId
                                                          ) === null
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "typography--font-weight-bold rank-left"
                                                                },
                                                                [_vm._v("-")]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "typography--font-weight-bold rank-left"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getSubmissionSubjectScore(
                                                                        student.submissions,
                                                                        _vm.selectedSubjectId
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm.classSubjectScoreRanks.indexOf(
                                                                _vm.getSubmissionSubjectScore(
                                                                  student.submissions,
                                                                  _vm.selectedSubjectId
                                                                )
                                                              ) >= 0
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.classSubjectScoreRanks.indexOf(
                                                                            _vm.getSubmissionSubjectScore(
                                                                              student.submissions,
                                                                              _vm.selectedSubjectId
                                                                            )
                                                                          ) + 1
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "reports.rank_suffix"
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v("-")
                                                                  ])
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " |   " +
                                                              _vm._s(
                                                                _vm.studentList
                                                                  .length
                                                              )
                                                          ),
                                                          _c("br"),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getCompleteRateSubject(
                                                                    student.submissions,
                                                                    _vm.selectedSubjectId
                                                                  ) || 0
                                                                ) + "%"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-footer clickable",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.studentToRecommend = student
                                                          _vm.openRecommendContentModal()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.go_to_recommend_contents"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                    _vm._v(" "),
                                    _vm.needHelpStudentList.length === 0
                                      ? _c(
                                          "Card",
                                          {
                                            staticClass:
                                              "report-students-no-card"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row no-need-help-container"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      "/static/images/friends-img.png"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "no-need-help-text"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "no-need-help-text1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.no_need_help_students"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "no-need-help-text2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.students_well_following"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 1 &&
                            _vm.needHelpStudentList.length > _vm.viewMoreLength
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "view-more-container text-center",
                                    on: {
                                      click: function($event) {
                                        _vm.viewMoreNeedHelp = !_vm.viewMoreNeedHelp
                                      }
                                    }
                                  },
                                  [
                                    !_vm.viewMoreNeedHelp
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_more"))
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_less"))
                                          )
                                        ]),
                                    _vm._v(
                                      "\n                \n              "
                                    ),
                                    !_vm.viewMoreNeedHelp
                                      ? _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-down.svg"
                                          }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-up.svg"
                                          }
                                        })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2
                              ? _c(
                                  "div",
                                  { staticClass: "card-block row" },
                                  _vm._l(_vm.sortedStudentList, function(
                                    student,
                                    index
                                  ) {
                                    return _vm.viewMoreTotalStudents ||
                                      index < _vm.viewMoreLength
                                      ? _c(
                                          "Card",
                                          {
                                            staticClass: "report-students-card"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "report-students-card-header clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$router.push(
                                                      "/reports/classes/" +
                                                        _vm.cls.id +
                                                        "/students/" +
                                                        student.student_id +
                                                        "?subject_id=" +
                                                        _vm.selectedSubjectId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class: {
                                                      "report-students-card-header-time":
                                                        _vm.getTotalDuration(
                                                          student.submissions
                                                        ) !== 0,
                                                      "report-students-card-header-time-disabled":
                                                        _vm.getTotalDuration(
                                                          student.submissions
                                                        ) === 0
                                                    }
                                                  },
                                                  [
                                                    _vm.getTotalDuration(
                                                      student.submissions
                                                    ) !== 0
                                                      ? _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/images/time-icon.svg"
                                                          }
                                                        })
                                                      : _c("img", {
                                                          attrs: {
                                                            src:
                                                              "/static/images/time-gray-icon.svg"
                                                          }
                                                        }),
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.formattedTime(
                                                            _vm.getTotalDuration(
                                                              student.submissions
                                                            )
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "student-number"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumStrTwoDigit(
                                                          student.number
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" \n                  "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "student-name"
                                                  },
                                                  [_vm._v(_vm._s(student.name))]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "report-students-card-body clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$router.push(
                                                      "/reports/classes/" +
                                                        _vm.cls.id +
                                                        "/students/" +
                                                        student.student_id +
                                                        "?subject_id=" +
                                                        _vm.selectedSubjectId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-body-titles"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.table.score"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.rank"
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _c("br"),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reports.table.complete_rate"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "report-students-card-body-contents"
                                                    },
                                                    [
                                                      _vm.getSubmissionSubjectScore(
                                                        student.submissions,
                                                        _vm.selectedSubjectId
                                                      ) === null
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [_vm._v("-")]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "typography--font-weight-bold rank-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getSubmissionSubjectScore(
                                                                    student.submissions,
                                                                    _vm.selectedSubjectId
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typography--font-weight-bold rank-left"
                                                        },
                                                        [
                                                          _vm.classSubjectScoreRanks.indexOf(
                                                            _vm.getSubmissionSubjectScore(
                                                              student.submissions,
                                                              _vm.selectedSubjectId
                                                            )
                                                          ) >= 0
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.classSubjectScoreRanks.indexOf(
                                                                        _vm.getSubmissionSubjectScore(
                                                                          student.submissions,
                                                                          _vm.selectedSubjectId
                                                                        )
                                                                      ) + 1
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "reports.rank_suffix"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v("-")
                                                              ])
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " |   " +
                                                          _vm._s(
                                                            _vm.studentList
                                                              .length
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "typography--font-weight-bold rank-left"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getCompleteRateSubject(
                                                                student.submissions,
                                                                _vm.selectedSubjectId
                                                              ) || 0
                                                            ) + "%"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("br")
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedStudentReport === 2 &&
                            _vm.studentList.length > _vm.viewMoreLength
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "view-more-container text-center",
                                    on: {
                                      click: function($event) {
                                        _vm.viewMoreTotalStudents = !_vm.viewMoreTotalStudents
                                      }
                                    }
                                  },
                                  [
                                    !_vm.viewMoreTotalStudents
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_more"))
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.view_less"))
                                          )
                                        ]),
                                    _vm._v(
                                      "\n                \n              "
                                    ),
                                    !_vm.viewMoreTotalStudents
                                      ? _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-down.svg"
                                          }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: "/static/images/arrow-up.svg"
                                          }
                                        })
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "card-row mb-12" }, [
                            _c(
                              "div",
                              { staticClass: "row ml-0 mr-0" },
                              [
                                _c(
                                  "Card",
                                  {
                                    staticClass: "graph-summary-stat-container"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row pl-10 graph-header" },
                                      [
                                        _vm.selectedGraph === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "graph-summary-stat"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "reports.all_students_count"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "total-students-number"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.studentList.length
                                                      ) +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.modal.preview.count"
                                                          )
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.selectedGraph === 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "graph-summary-stat"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "avg-score" },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.average_score"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-narrow"
                                                      },
                                                      [
                                                        _vm.diffAvgScore > 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore === 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore < 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "avg-score-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentAvgScore
                                                          ) + "점"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-wide"
                                                      },
                                                      [
                                                        _vm.diffAvgScore > 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore === 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffAvgScore < 0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "diff-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getNumStrTwoDigit(
                                                              Math.abs(
                                                                _vm.diffAvgScore
                                                              )
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c("br")
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "avg-submit-rate"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.submit_assignment"
                                                          )
                                                        ) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-narrow"
                                                      },
                                                      [
                                                        _vm.diffSubmissionRate >
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate ===
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate <
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "avg-submit-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentSubmissionRate ||
                                                              0
                                                          ) + "%"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "show-when-wide"
                                                      },
                                                      [
                                                        _vm.diffSubmissionRate >
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-up.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate ===
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/non-arrow.svg"
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.diffSubmissionRate <
                                                        0
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "/static/images/arrow-down.svg"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "diff-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getNumStrTwoDigit(
                                                              Math.abs(
                                                                _vm.diffSubmissionRate ||
                                                                  0
                                                              )
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-selectgraph clickable",
                                            class: {
                                              "btn-rectangle-primary":
                                                _vm.selectedGraph === 1,
                                              "typography--color-secondary":
                                                _vm.selectedGraph !== 1,
                                              "btn-outline-rectangle-disabled":
                                                _vm.selectedGraph !== 1
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.selectedGraph = 1
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("reports.achievement")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-selectgraph clickable",
                                            class: {
                                              "btn-rectangle-primary":
                                                _vm.selectedGraph === 2,
                                              "typography--color-secondary":
                                                _vm.selectedGraph !== 2,
                                              "btn-outline-rectangle-disabled":
                                                _vm.selectedGraph !== 2
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.selectedGraph = 2
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "reports.achievement_trend"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedGraph === 1
                                      ? _c("BarChart", {
                                          attrs: {
                                            height: 150,
                                            chartData:
                                              _vm.achievementDistribution,
                                            totalStudents:
                                              _vm.studentList.length
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedGraph === 2
                                      ? _c("LineChart", {
                                          attrs: {
                                            height: 150,
                                            chartData: _vm.trendData
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("Card", { staticClass: "study-state" }, [
                                  _c(
                                    "div",
                                    { staticClass: "study-state-title" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("reports.study_status"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "study-state-time" },
                                    [
                                      _c("DoughnutChart", {
                                        attrs: {
                                          chartData: _vm.activeStudentData
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "study-state-time-text1 text-center"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "bold-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.floor(
                                                      _vm.getAverageDuration(
                                                        _vm.getSubmissionsThisWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) / 3600
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("h\n                      "),
                                          _c(
                                            "span",
                                            { staticClass: "bold-number" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.ceil(
                                                      (_vm.getAverageDuration(
                                                        _vm.getSubmissionsThisWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) /
                                                        60) %
                                                        60
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("m\n                    ")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "study-state-time-text2 text-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "reports.last_week_avg_time"
                                                )
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.floor(
                                                      _vm.getAverageDuration(
                                                        _vm.getSubmissionsUntilLastWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) / 3600
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("h\n                      "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "typography--font-weight-bold"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getNumStrTwoDigit(
                                                    Math.ceil(
                                                      (_vm.getAverageDuration(
                                                        _vm.getSubmissionsUntilLastWeek(
                                                          _vm
                                                            .submissionsBySubjects[
                                                            _vm
                                                              .selectedSubjectId
                                                          ]
                                                        )
                                                      ) /
                                                        60) %
                                                        60
                                                    )
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v("m\n                    ")
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "ws-nowrap pb-6 font-14" },
                                    [
                                      _c("div", {
                                        staticClass: "active-legend"
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("reports.active_students")
                                        ) + "   "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "bold-number" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                _vm.getActiveStudents()
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c("br")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "ws-nowrap font-14" },
                                    [
                                      _c("div", {
                                        staticClass: "inactive-legend"
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("reports.inactive_students")
                                        ) + "   "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "bold-number" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                _vm.studentList.length -
                                                  _vm.getActiveStudents()
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                : _c("div", [
                    _c("div", { staticClass: "class-report-allsubs" }, [
                      _c("table", { staticClass: "mw-960" }, [
                        _c("tbody", [
                          _c(
                            "tr",
                            [
                              _c("td"),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c(
                                  "th",
                                  {
                                    staticClass: "clickable",
                                    on: {
                                      click: function($event) {
                                        _vm.selectedSubjectId = subjectId
                                        _vm.selectedReport = 1
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTranslatedName(
                                          _vm.subjectMap[subjectId]
                                        )
                                      )
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(_vm._s(_vm.$t("reports.avg_score")))
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--font-weight-bold",
                                      class: {
                                        "color-00c896":
                                          _vm.diffScoreBySubjects[subjectId] >
                                          0,
                                        "color-f97e76":
                                          _vm.diffScoreBySubjects[subjectId] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.averageScoreBySubjects[
                                              subjectId
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "diff-up":
                                          _vm.diffScoreBySubjects[subjectId] >
                                          0,
                                        "diff-neutral":
                                          _vm.diffScoreBySubjects[subjectId] ===
                                          0,
                                        "diff-down":
                                          _vm.diffScoreBySubjects[subjectId] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedDiff(
                                              _vm.diffScoreBySubjects[subjectId]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.$t("reports.average_duration"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "time-up":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] > 0,
                                        "time-down":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                Math.floor(
                                                  _vm.averageDurationBySubjects[
                                                    subjectId
                                                  ] / 3600
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v("h\n                  "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "typography--font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getNumStrTwoDigit(
                                                Math.ceil(
                                                  (_vm
                                                    .averageDurationBySubjects[
                                                    subjectId
                                                  ] /
                                                    60) %
                                                    60
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v("m\n                ")
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] < 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/red-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] === 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/non-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.diffDurationBySubjects[subjectId] > 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            "/static/images/grn-time-icon.svg"
                                        }
                                      })
                                    : _vm._e(),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "color-00c896":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] > 0,
                                        "color-f97e76":
                                          _vm.diffDurationBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedTime(
                                              _vm.diffDurationBySubjects[
                                                subjectId
                                              ]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _c("td", [
                                _vm._v(_vm._s(_vm.$t("reports.complete_rate")))
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.subjectIds, function(subjectId) {
                                return _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "typography--font-weight-bold",
                                      class: {
                                        "color-00c896":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] > 0,
                                        "color-f97e76":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.averageSubmitrateBySubjects[
                                              subjectId
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-12",
                                      class: {
                                        "diff-up":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] > 0,
                                        "diff-neutral":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] === 0,
                                        "diff-down":
                                          _vm.diffSubmitrateBySubjects[
                                            subjectId
                                          ] < 0
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formattedDiff(
                                              _vm.diffSubmitrateBySubjects[
                                                subjectId
                                              ]
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _c("br"),
                    _c("br"),
                    _c("br"),
                    _c("br")
                  ])
            ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal student-manage-modal",
            attrs: {
              id: "student-manage-modal",
              title: _vm.$t("reports.manage_students")
            }
          },
          [
            _c(
              "div",
              { staticClass: "student-manage-table-container scroll-box" },
              [
                _c("table", { staticClass: "table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th"),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.number")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.name")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass:
                            "typography--body-3 typography--color-secondary"
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("reports.table.gender")) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.managingStudentList, function(student, index) {
                      return _c("tr", { key: student.student_id }, [
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-secondary"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mdc-form-field" },
                              [
                                _c("Checkbox", {
                                  attrs: {
                                    "model-value": _vm.checkedStudents,
                                    "check-value": student,
                                    id: "student-checkbox-" + student.student_id
                                  },
                                  on: { change: _vm.selectStudent }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-primary"
                          },
                          [_vm._v(_vm._s(index + 1))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-primary"
                          },
                          [_vm._v(_vm._s(student.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "align-middle typography--body-3 typography--color-secondary"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mdc-form-field" },
                              [
                                _c(
                                  "Radio",
                                  {
                                    attrs: {
                                      "model-value": student.gender,
                                      "check-value": 1,
                                      id: "male-student"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectStudentGender(
                                          student,
                                          1
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.gender.1"))
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "Radio",
                                  {
                                    attrs: {
                                      "model-value": student.gender,
                                      "check-value": 2,
                                      id: "female-student"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.selectStudentGender(
                                          student,
                                          2
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("reports.gender.2"))
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                attrs: { slot: "modal-footer" },
                slot: "modal-footer"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "float-left btn btn-outline-primary btn-fab btn-mini-fab mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.moveStudentNumber("up")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("keyboard_arrow_up")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "float-left btn btn-outline-primary btn-fab btn-mini-fab",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.moveStudentNumber("down")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("keyboard_arrow_down")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary float-right close-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.updateStudents }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.save")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary float-right close-btn mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "hide::modal",
                          "student-manage-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.cancel")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal",
            attrs: {
              id: "recommend-content-modal",
              title:
                this.$t("reports.go_to_recommend_contents") +
                " | " +
                _vm.getTranslatedName(_vm.subjectMap[_vm.selectedSubjectId])
            }
          },
          [
            _c("div", { staticClass: "recommend-content-container" }, [
              _c("div", { staticClass: "recommend-content-studentname" }, [
                _c("div", { staticClass: "recommend-content-header-time" }, [
                  _vm.getTotalDuration(_vm.studentToRecommend.submissions) !== 0
                    ? _c("img", {
                        attrs: { src: "/static/images/time-icon.svg" }
                      })
                    : _c("img", {
                        attrs: { src: "/static/images/time-gray-icon.svg" }
                      }),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.formattedTime(
                          _vm.getTotalDuration(
                            _vm.studentToRecommend.submissions
                          )
                        )
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "typography--font-weight-bold typography--color-secondary"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getNumStrTwoDigit(_vm.studentToRecommend.number)
                        ) +
                        "   " +
                        _vm._s(_vm.studentToRecommend.name)
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "recommend-content-studentinfo" }, [
                _c("div", { staticClass: "recommend-content-item-left" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("reports.table.score")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-right color-000000" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getSubmissionSubjectScore(
                            _vm.studentToRecommend.submissions,
                            _vm.selectedSubjectId
                          )
                        ) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "recommend-content-item-left" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.rank")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-right color-000000" },
                  [
                    _vm.classSubjectScoreRanks.indexOf(
                      _vm.getSubmissionSubjectScore(
                        _vm.studentToRecommend.submissions,
                        _vm.selectedSubjectId
                      )
                    ) >= 0
                      ? _c(
                          "span",
                          { staticClass: "typography--font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.classSubjectScoreRanks.indexOf(
                                    _vm.getSubmissionSubjectScore(
                                      _vm.studentToRecommend.submissions,
                                      _vm.selectedSubjectId
                                    )
                                  ) + 1
                                ) +
                                _vm._s(_vm.$t("reports.rank_suffix")) +
                                "\n            "
                            )
                          ]
                        )
                      : _c(
                          "span",
                          { staticClass: "typography--font-weight-bold" },
                          [
                            _vm._v(
                              _vm._s(_vm.classSubjectScoreRanks.length + 1) +
                                _vm._s(_vm.$t("reports.rank_suffix"))
                            )
                          ]
                        ),
                    _vm._v(
                      " / " + _vm._s(_vm.studentList.length) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "recommend-content-item-left text-right" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("reports.table.complete_rate")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "recommend-content-item-right typography--font-weight-bold color-000000 text-right"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.getCompleteRateSubject(
                            _vm.studentToRecommend.submissions,
                            _vm.selectedSubjectId
                          )
                        ) +
                        "%\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.getRecommendUnits(_vm.studentToRecommend).length === 0
                ? _c("div", { staticClass: "text-center pt-30 pb-20" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("reports.no_recommend_chapters")) +
                        "\n        "
                    )
                  ])
                : _c(
                    "div",
                    _vm._l(
                      _vm.getRecommendUnits(_vm.studentToRecommend),
                      function(unitId) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.units[unitId],
                                expression: "units[unitId]"
                              }
                            ],
                            key: unitId,
                            staticClass: "recommend-content-chapter clickable",
                            on: {
                              click: function($event) {
                                return _vm.goToLibrary(
                                  _vm.selectedSubjectId,
                                  _vm.cls,
                                  unitId
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "recommend-content-chapter-score"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("reports.table.score")) +
                                    "  \n              "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "typography--font-weight-bold recommend-content-chapter-score-number"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getAverageScore(
                                            _vm.getSubmissionsOfUnit(
                                              _vm.studentToRecommend
                                                .submissions,
                                              unitId
                                            )
                                          ) || 0
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getUnitLabel(_vm.units[unitId])) +
                                "\n          "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-100",
                attrs: { slot: "modal-footer" },
                slot: "modal-footer"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary float-right close-btn mr-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "hide::modal",
                          "recommend-content-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.close")) +
                        "\n        "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _vm.selectAssignmentModalIsShown
          ? _c("SelectAssignmentModal", {
              attrs: {
                "assignment-list":
                  _vm.assignmentsBySubjects[_vm.selectedSubjectId],
                "pre-selected-list": _vm.selectedAssignmentList,
                "has-selected-all-assignments": _vm.hasSelectedAllAssignments
              },
              on: {
                cancel: function($event) {
                  _vm.selectAssignmentModalIsShown = false
                },
                "assignments-selected": _vm.onAssignmentsSelected
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc86192a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc86192a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/classes/views/ClassReport.vue
// module id = 9In3
// module chunks = 1